import React from "react";

import AnnualReport2024 from "../../../../files/annual_reports/Annual_Report_2024.pdf";
import AnnualReport2023 from "../../../../files/annual_reports/Annual-Report-2023.pdf";
import AnnualReport2022 from "../../../../files/annual_reports/Annual-Report-2022.pdf";
import AnnualReport2021 from "../../../../files/annual_reports/ANNUAL_REPORT-2021.pdf";
import AnnualReport2020 from "../../../../files/annual_reports/AnnualReport2020.pdf";
import AnnualReport2019 from "../../../../files/annual_reports/AnnualReport2019.pdf";
import AnnualReport2018 from "../../../../files/annual_reports/AnnualReport2018.pdf";
import AnnualReport2017 from "../../../../files/annual_reports/AnnualReport2017.pdf";

const AnnualReports = () => {
  return (
    <>
      <div className="row mt-5">
        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2024</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2024}>
                  Annual Report 2024
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2023</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2023}>
                  {/* 3rd Quarter (un-audited) */}
                  Annual Report 2023
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2022</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2022}>
                  Annual Report 2022
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2021</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2021}>
                  Annual Report 2021
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2020</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2020}>
                  Annual Report 2020
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2019</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2019}>
                  Annual Report 2019
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2018</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2018}>
                  Annual Report 2018
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2017</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={AnnualReport2017}>
                  Annual Report 2017
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnualReports;
